import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { AspViewDocumentComponent } from './asp-view-document.component';
import { MatIconModule } from '@angular/material/icon';



const routes: Routes = [
  { path: 'view-documents', component: AspViewDocumentComponent},
  
];

@NgModule({
  declarations: [AspViewDocumentComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    HttpClientModule,
    MatIconModule,
  ]
})
export class AspViewDocumentModule { }
